import { FC } from 'react';
import { IElementSystemIcon, IGlobalHeaderUrls } from '@belong/types';
import { GLOBAL_HEADER_TEST_ID as TEST_ID } from '../../testids';
import { ARIA_CURRENT } from '../../variables';
import { GHMobileLink } from '../GHMobileLink';
import { LinkWrapper, LogoutButton } from './styles';

interface IGHMobileAccountButton {
  handleLogoutClick: () => void;
  handleClose: () => void;
  urls: IGlobalHeaderUrls;
  currentUrl: string | undefined;
  isLoggedIn: boolean;
  loginLabel: string;
  loginIcon: IElementSystemIcon;
  logoutLabel: string;
  logoutIcon: IElementSystemIcon;
}

const LOG_IN_ARIA_LABEL = 'Log in to my account';

export const GHMobileAccountButton: FC<IGHMobileAccountButton> = ({
  isLoggedIn,
  loginLabel,
  loginIcon,
  logoutLabel,
  logoutIcon,
  urls,
  currentUrl,
  handleClose,
  handleLogoutClick
}) => {
  return (
    <>
      {isLoggedIn ? (
        <LinkWrapper>
          <LogoutButton
            label={logoutLabel}
            variant="primary"
            onClick={handleLogoutClick}
            icon={logoutIcon.icon}
            data-testid={TEST_ID.MOBILE_MENU_BUTTON_LOGOUT}
            isLightColor
            hasIconLeft
          />
        </LinkWrapper>
      ) : (
        <GHMobileLink
          aria-current={currentUrl === urls.login ? ARIA_CURRENT : undefined}
          data-testid={TEST_ID.MOBILE_MENU_BUTTON_LOGIN}
          href={urls.login}
          iconName={loginIcon.icon}
          label={loginLabel}
          aria-label={LOG_IN_ARIA_LABEL}
          onClick={handleClose}
        />
      )}
    </>
  );
};

GHMobileAccountButton.displayName = 'GHMobileAccountButton';
